export enum FieldNames {
    NAME = "Nazwa",
    ADDRESS = "Adres",
    USER = "Reprezentant",
    EMAIL = "E-mail",
    PHONE = "Telefon",
    ORDERTYPE = "receptionPlacesOrderTypes",
    BDO = "Number BDO",
  }